var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon blueSVGs",
    width: 22,
    height: 22,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teacher"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1082",
    cx: 8,
    cy: 4.98047,
    r: 2.5,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 416",
    d: "M4.39838 14.4128C3.81065 14.05 3.5 13.3499 3.5 12.5537L3.5 11.251C3.5 9.66065 5.17362 8.62629 6.59605 9.33751C7.47986 9.77941 8.52014 9.77941 9.40395 9.33751C10.8264 8.62629 12.5 9.66065 12.5 11.251L12.5 12.5537C12.5 13.3499 12.1894 14.05 11.6016 14.4128C10.7722 14.9249 9.5204 15.4805 8 15.4805C6.4796 15.4805 5.22779 14.9249 4.39838 14.4128Z",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/Teacher.bf2d6156987f08eda4a58640a2f589f6.svg";
export { ForwardRef as ReactComponent };